export default "__VITE_ASSET__bd6fde4a__"